<template>
  <t-checkbox v-model="checkboxValue"
              :disabled="isDisabled"
              :ref="id"
              class="accent-primary-focus flex"
              :variant="isDisabled ? 'disabled' : variant"
              :id="id"
              :wrapped="isWrapped"
  >
    <slot/>
  </t-checkbox>
</template>

<script>

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    isChecked: {
      type: Boolean,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isWrapped: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    checkboxValue: {
      get() {
        return this.isChecked
      },
      set(isChecked) {
        this.$emit('update:isChecked', isChecked)
      }
    },

    variant() {
      return this.isWrapped ? 'wrapped' : 'default'
    }
  },

  methods: {
    displayIndeterminate(isDisplayed) {
      this.$refs[this.id].setIndeterminate(isDisplayed)
    }
  }
}
</script>

<style scoped>
.accent-primary-focus {
  accent-color: theme('colors.primary-focus');
}
</style>
